import { NavigationItem } from "./types";

export const NAVIGATION: NavigationItem[] = [
  {
    title: "Home",
    icon: "house",
    iconActive: "houseFill",
    path: "dashboard",
  },
  {
    title: "Transfer",
    icon: "transfer",
    iconActive: "transferFill",
    // path: "transfer",
  },
  {
    title: "Income",
    icon: "deposit",
    iconActive: "depositFill",
    // path: "deposit",
  },
  {
    title: "Pay Bills",
    icon: "invoice",
    iconActive: "invoiceFill",
    // path: "bill-pay",
  },
];
